import { render, staticRenderFns } from "./tear-off-calendar.vue?vue&type=template&id=2a1a5c02"
import script from "./tear-off-calendar.vue?vue&type=script&lang=js"
export * from "./tear-off-calendar.vue?vue&type=script&lang=js"
import style0 from "./tear-off-calendar.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports